import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.282 6.343a.75.75 0 0 1 1.06-1.06l12.375 12.374a.75.75 0 0 1-1.06 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.657 5.282a.75.75 0 0 1 1.06 1.06L6.343 18.718a.75.75 0 1 1-1.06-1.06z"
  }));
}
var IcClose = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClose));

export { IcClose as I };
